import React from 'react'
import {
	Box, Card, CardContent, Typography, Table, TableHead, TableBody, TableRow, TableCell,
	Grid, Chip, IconButton
} from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'


const FLAG = { ES: '🇪🇸', GB: '🇬🇧', FR: '🇫🇷', IT: '🇮🇹' }

const ACRISS_ROWS = [
	{
		offices: ['Madrid T4', 'Barcelona El Prat'],
		countries: [{ code: 'ES', name: 'Spain' }],
		sites: ['PriceFly', 'RentalSpot'],
		acriss: 'CDMR',
		providers: 'DrivePro, FleetMax',
		carModel: 'Seat Ibiza',
		doors: '5',
		seats: '5',
		transmission: 'Manual',
		ac: 'Yes',
		owner: 'Company',
	},
	{
		offices: ['Malaga Costa del Sol'],
		countries: [{ code: 'ES', name: 'Spain' }],
		sites: ['BookRide'],
		acriss: 'ECMR',
		providers: 'CarFirst',
		carModel: 'Renault Clio',
		doors: '5',
		seats: '5',
		transmission: 'Manual',
		ac: 'Yes',
		owner: 'User',
	},
	{
		offices: [],
		countries: [{ code: 'GB', name: 'United Kingdom' }],
		sites: ['SwiftFleet', 'PriceFly'],
		acriss: 'FWAR',
		providers: 'Any',
		carModel: 'Ford Focus Estate',
		doors: '5',
		seats: '5',
		transmission: 'Automatic',
		ac: 'Yes',
		owner: 'Company',
	},
	{
		offices: ['Paris CDG'],
		countries: [{ code: 'FR', name: 'France' }],
		sites: [],
		acriss: 'IDAR',
		providers: 'SpeedCar, AutoRent',
		carModel: 'BMW 3 Series',
		doors: '4',
		seats: '5',
		transmission: 'Automatic',
		ac: 'Yes',
		owner: 'User',
	},
]

const CATEGORY_ROWS = [
	{
		offices: ['Madrid T4'],
		countries: [{ code: 'ES', name: 'Spain' }],
		sites: ['RentalSpot'],
		category: 'Economy',
		providers: 'FleetMax, CarFirst',
		carModel: 'Fiat 500',
		doors: '3',
		seats: '4',
		transmission: 'Manual',
		ac: 'Any',
		owner: 'Company',
	},
	{
		offices: [],
		countries: [{ code: 'IT', name: 'Italy' }],
		sites: ['PriceFly'],
		category: 'Compact',
		providers: 'Any',
		carModel: 'VW Golf',
		doors: '5',
		seats: '5',
		transmission: 'Any',
		ac: 'Yes',
		owner: 'Company',
	},
	{
		offices: ['Tenerife South'],
		countries: [{ code: 'ES', name: 'Spain' }],
		sites: [],
		category: 'SUV',
		providers: 'DrivePro',
		carModel: 'Nissan Qashqai',
		doors: '5',
		seats: '5',
		transmission: 'Automatic',
		ac: 'Yes',
		owner: 'User',
	},
]

const SITE_COLORS = {
	'PriceFly': '#FF690F',
	'RentalSpot': '#007BC1',
	'BookRide': '#00A651',
	'SwiftFleet': '#0770E3',
}

const HEADER_SX = { bgcolor: 'primary.main', color: 'white', fontWeight: 600, fontSize: '0.68rem', whiteSpace: 'nowrap', p: 1 }


function MappingTable({ title, rows, codeLabel, codeField }) {
	return <Card>
		<CardContent sx={{ p: 2 }}>
			<Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>{title}</Typography>
			<Box sx={{ overflowX: 'auto' }}>
				<Table size="small">
					<TableHead>
						<TableRow sx={{ '& th': HEADER_SX }}>
							<TableCell>Offices</TableCell>
							<TableCell>Countries</TableCell>
							<TableCell>Sites</TableCell>
							<TableCell>{codeLabel}</TableCell>
							<TableCell>Providers</TableCell>
							<TableCell>Car Model</TableCell>
							<TableCell>Doors</TableCell>
							<TableCell>Seats</TableCell>
							<TableCell>Trans.</TableCell>
							<TableCell>A/C</TableCell>
							<TableCell>Owner</TableCell>
							<TableCell sx={{ textAlign: 'center' }}>Actions</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map((row, ri) => (
							<TableRow key={ri} sx={{ backgroundColor: ri % 2 === 0 ? '#fafafa' : '#f5f5f5' }}>
								<TableCell sx={{ fontSize: '0.72rem' }}>
									{row.offices.length > 0
										? row.offices.map((o, i) => <Chip key={i} label={o} size="small" variant="outlined" sx={{ fontSize: '0.62rem', m: 0.2 }} />)
										: <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary' }}>Any</Typography>
									}
								</TableCell>
								<TableCell sx={{ fontSize: '0.72rem' }}>
									{row.countries.map((c, i) => (
										<Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
											<Typography sx={{ fontSize: '0.9rem' }}>{FLAG[c.code]}</Typography>
											<Typography sx={{ fontSize: '0.72rem' }}>{c.name}</Typography>
										</Box>
									))}
								</TableCell>
								<TableCell>
									<Box sx={{ display: 'flex', gap: 0.3, flexWrap: 'wrap' }}>
										{row.sites.length > 0
											? row.sites.map((s, i) => <Chip key={i} label={s} size="small" sx={{ fontSize: '0.6rem', bgcolor: SITE_COLORS[s] || 'grey.400', color: 'white', fontWeight: 600 }} />)
											: <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary' }}>Any</Typography>
										}
									</Box>
								</TableCell>
								<TableCell sx={{ fontWeight: 700, fontSize: '0.78rem' }}>{row[codeField]}</TableCell>
								<TableCell sx={{ fontSize: '0.72rem' }}>{row.providers}</TableCell>
								<TableCell sx={{ fontSize: '0.72rem', maxWidth: 120 }}>
									<Typography sx={{ fontSize: '0.72rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
										{row.carModel}
									</Typography>
								</TableCell>
								<TableCell sx={{ textAlign: 'center', fontSize: '0.72rem' }}>{row.doors}</TableCell>
								<TableCell sx={{ textAlign: 'center', fontSize: '0.72rem' }}>{row.seats}</TableCell>
								<TableCell sx={{ fontSize: '0.72rem' }}>{row.transmission}</TableCell>
								<TableCell sx={{ fontSize: '0.72rem' }}>{row.ac}</TableCell>
								<TableCell sx={{ fontSize: '0.72rem' }}>
									<Chip label={row.owner} size="small" variant="outlined"
										sx={{ fontSize: '0.62rem', borderColor: row.owner === 'Company' ? 'primary.main' : 'secondary.main' }}
									/>
								</TableCell>
								<TableCell sx={{ textAlign: 'center' }}>
									<Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
										<IconButton size="small">
											<IconSeeker icon="pen" sx={{ fontSize: 13, color: 'warning.main' }} />
										</IconButton>
										<IconButton size="small">
											<IconSeeker icon="trash-can" sx={{ fontSize: 13, color: 'error.main' }} />
										</IconButton>
									</Box>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Box>
		</CardContent>
	</Card>
}


export default function MappingDemoData() {
	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<MappingTable
				title="Custom ACRISS Mapping List"
				rows={ACRISS_ROWS}
				codeLabel="ACRISS Code"
				codeField="acriss"
			/>
		</Grid>
		<Grid item xs={12}>
			<MappingTable
				title="Custom Categories Mapping List"
				rows={CATEGORY_ROWS}
				codeLabel="Category"
				codeField="category"
			/>
		</Grid>
	</Grid>
}
